const Address = require('./Address');
const Parent = require('./Parent');

class Navigator {
  constructor() {
    this.init();
  }

  init() {
    this.navigator_id = undefined;
    this.name = undefined;
    this.access = undefined;
    this.contact = undefined;
    this.email = undefined;
    this.phone_number = undefined;
    this.address = new Address();
    this.parents = [];
  }

  copy() {
    const cp = new Navigator();

    cp.navigator_id = this.navigator_id;
    cp.name = this.name;
    cp.access = this.access;
    cp.contact = this.contact;
    cp.email = this.email;
    cp.phone_number = this.phone_number;
    cp.address = this.address;

    cp.parents = [];
    this.parents.forEach((p) => {
      cp.parents.push(p);
    })
    return cp;
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      this.navigator_id = obj.navigator_id ? obj.navigator_id.toString() : undefined;
      this.name = obj.name ? obj.name : undefined;
      this.access = obj.access ? obj.access : undefined;
      this.contact = obj.contact ? obj.contact : undefined;
      this.email = obj.email ? obj.email : undefined;
      this.phone_number = obj.phone_number ? obj.phone_number : undefined;
      this.address.buildFromJSON(obj.address ? obj.address : {});

      this.parents = [];
      if (obj.parents && Array.isArray(obj.parents)) {
        obj.parents.forEach((p) => {
          const parent = new Parent();
          parent.buildFromJSON(p);
          this.parents.push(parent);
        });
      }
    }
  }

  toString() {
    let result = this.name;

    if (this.email) {
      result = `${result}: (${this.email})`;
    }
    if (this.phone_number) {
      result = (this.email) ? `${result} ${this.phone_number}` : `${result}: ${this.phone_number}`;
    }

    return result;
  }

  getId() {
    return this.navigator_id;
  }

  setId(navigator_id) {
    this.navigator_id = navigator_id ? navigator_id.toString() : undefined;
  }

  getName() {
    return this.name;
  }

  setName(name) {
    this.name = name;
  }

  getAccess() {
    return this.access;
  }

  setAccess(access) {
    this.access = access;
  }

  getContact() {
    return this.contact;
  }

  setContact(contact) {
    this.contact = contact;
  }

  getEmail() {
    return this.email;
  }

  setEmail(email) {
    this.email = email;
  }

  getPhoneNumber() {
    return this.phone_number;
  }

  setPhoneNumber(phone_number) {
    this.phone_number = phone_number;
  }

  getAddress() {
    return this.address;
  }

  setAddress(address) {
    this.address = address;
  }

  getParents() {
    return this.parents;
  }

  setParents(parents) {
    this.parents = [];

    if (parents && Array.isArray(parents)) {
      parents.forEach((p) => {
        this.parents.push(p.copy());
      });
    }
  }
}

module.exports = Navigator;
